import { render } from "./SecretOrigin.vue?vue&type=template&id=5bc85f7d&scoped=true"
import script from "./SecretOrigin.vue?vue&type=script&lang=js"
export * from "./SecretOrigin.vue?vue&type=script&lang=js"

import "./SecretOrigin.vue?vue&type=style&index=0&id=5bc85f7d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bc85f7d"]])

export default __exports__